import type { Driver, NewDriver } from '@cobliteam/api-lib';

export const trimDriverName = (driver: Driver | NewDriver): Driver | NewDriver => {
  return {
    ...driver,
    name: driver.name.trim(),
  };
};
